import { render, staticRenderFns } from "./AlertaBasePantalla.vue?vue&type=template&id=5a179b49&"
import script from "./AlertaBasePantalla.vue?vue&type=script&lang=ts&"
export * from "./AlertaBasePantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports